import { LEARN_TAROT_ENABLED } from '../pages/LearnTarot/learnData';

export const SPREAD_LINKS = [
  { to: '/birth-chart/', label: 'Birth Chart', badge: 'New' },
  { to: '/free-tarot/', label: 'Free Tarot Reading' },
  { to: '/yes-or-no-tarot/', label: 'Yes or No Tarot' },
  { to: '/three-card-tarot/', label: '3-Card Past, Present, Future' },
  { to: '/love-tarot-reading/', label: 'Love Tarot Reading' },
  { to: '/career-tarot-reading/', label: 'Career Tarot' },
  { to: '/celtic-cross-tarot/', label: 'Celtic Cross' },
  { to: '/daily-tarot-reading/', label: 'Daily Tarot Reading' },
  { to: '/new-love-tarot-reading/', label: 'New Love Tarot' },
  { to: '/mind-body-spirit-tarot/', label: 'Mind Body Spirit' },
  { to: '/six-card-tarot-spread/', label: '6-Card Spread' },
  { to: '/tarot-card-interpreter/', label: 'Interpret Your Own Cards' },
];

export const READING_LINKS = [
  ...SPREAD_LINKS.filter((link) => !link.badge),
  { to: '/ai-psychic/', label: 'AI Psychic' },
  { to: '/tarot-card-meanings/', label: 'Tarot Card Meanings' },
  ...(LEARN_TAROT_ENABLED ? [{ to: '/learn-tarot/', label: 'Learn Tarot' }] : []),
];

export const ASTRO_LINKS = [
  { to: '/birth-chart/', label: 'Birth Chart' },
  { to: '/big-three-calculator/', label: 'Big Three Calculator' },
  { to: '/rising-sign-calculator/', label: 'Rising Sign' },
  { to: '/moon-sign-calculator/', label: 'Moon Sign' },
  { to: '/venus-sign-calculator/', label: 'Venus Sign' },
  { to: '/zodiac-compatibility/', label: 'Zodiac Compatibility' },
  { to: '/birth-chart-compatibility/', label: 'Birth Chart Compatibility' },
  { to: '/personalized-daily-horoscope/', label: 'Your Astrology Today', badge: 'New' },
  { to: '/moon-phase-today/', label: 'Moon Phase Today' },
  { to: '/life-path-number-calculator/', label: 'Life Path Number' },
  { to: '/tarot-birth-card-calculator/', label: 'Tarot Birth Card' },
];

export const MAIN_LINKS = [
  { key: 'yesNo', to: '/yes-or-no-tarot/', label: 'Yes or No Tarot' },
  { key: 'ask', to: '/', label: 'Ask Tarot AI', end: true },
  { key: 'meanings', to: '/tarot-card-meanings/', label: 'Tarot Card Meanings' },
];

// Ask and Card Meanings stay in-language on landings and meaning pages.
// Yes or No stays English because that page is English.
const LOCAL_NAV = {
  es: {
    ask: 'Preguntar al tarot con IA',
    askShort: 'Preguntar',
    meanings: 'Significados del tarot',
    askTo: '/es/',
    meaningsTo: '/es/significados-cartas-tarot/',
  },
  ar: {
    ask: 'اسأل قارئ التاروت بالذكاء الاصطناعي',
    askShort: 'اسأل التاروت',
    meanings: 'معاني بطاقات التاروت',
    askTo: '/ar/',
    meaningsTo: '/ar/tarot-card-meanings/',
  },
  zh: {
    ask: '询问 AI 塔罗',
    askShort: '询问塔罗',
    meanings: '塔罗牌含义',
    askTo: '/zh/',
    meaningsTo: '/zh/taluo-pai-yisi/',
  },
  de: {
    ask: 'Das KI-Tarot fragen',
    askShort: 'KI-Tarot',
    meanings: 'Tarotkarten-Bedeutungen',
    askTo: '/de/',
    meaningsTo: '/de/tarot-kartenbedeutungen/',
  },
  pl: {
    ask: 'Zapytaj tarota AI',
    askShort: 'Zapytaj',
    meanings: 'Znaczenia kart tarota',
    askTo: '/pl/',
    meaningsTo: '/pl/znaczenia-kart-tarota/',
  },
  pt: {
    ask: 'Perguntar ao tarô com IA',
    askShort: 'Tarô IA',
    meanings: 'Significados do tarô',
    askTo: '/pt/',
    meaningsTo: '/pt/significados-cartas-tarot/',
  },
  fr: {
    ask: 'Demander au tarot IA',
    askShort: 'Tarot IA',
    meanings: 'Significations du tarot',
    askTo: '/fr/',
    meaningsTo: '/fr/significations-cartes-tarot/',
  },
};

export function localNav(pathname) {
  const path = pathname.endsWith('/') ? pathname : `${pathname}/`;
  return Object.entries(LOCAL_NAV).find(([, copy]) => (
    path === copy.askTo || path.startsWith(copy.meaningsTo)
  )) || null;
}

export function mainLinksFor(pathname) {
  const match = localNav(pathname);
  if (!match) return MAIN_LINKS;
  const [lang, copy] = match;
  return MAIN_LINKS.map((link) => {
    if (link.key === 'ask') {
      return { ...link, to: copy.askTo, label: copy.ask, shortLabel: copy.askShort, lang, end: true };
    }
    if (link.key === 'meanings') {
      return { ...link, to: copy.meaningsTo, label: copy.meanings, lang };
    }
    return link;
  });
}

export function readingLinksFor(pathname) {
  const match = localNav(pathname);
  if (!match) return READING_LINKS;
  const [lang, copy] = match;
  return READING_LINKS.map((link) => (
    link.to === '/tarot-card-meanings/'
      ? { ...link, to: copy.meaningsTo, label: copy.meanings, lang }
      : link
  ));
}
